
<app-update-banner></app-update-banner>
<router-outlet></router-outlet>